import AttachFileIcon from '@mui/icons-material/AttachFile';
import EditIcon from "@mui/icons-material/Edit";
import { Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { TableHeadButton } from "../../components/ui/TableHeadButton";
import { FLAG_REDIRECT_FROM_DOCUMENTS, FLAG_REDIRECT_FROM_PREVIEW, getItem, getUserAuth, setItem } from "../../utils/LocalStorageUtils";
import { formatDateTime, isForeigner, toLocalePrice } from "../../utils/StringUtil";
import { BASE_URL, SIGN_STATUS_FAILED, SIGN_STATUS_PENDING, SIGN_STATUS_SUCCESS } from "../../utils/constants/constants";
import { apigetFatcaList, apigetMcaList, apigetNominationList, getNominationEsignURL } from "../apis/apis";
import CustomSnackbar from "../components/Toast/CustomSnackbar";
import CardLayout from "../components/layout/CardLayout";

function McaNominationDocuments({ investor }) {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [errorData, setErrorData] = useState();
  const [nominationList, setNominationList] = useState([]);
  const [mcaList, setMcaList] = useState([]);
  const [fatcaList, setFatcaList] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const getNominationDetails = () => {
    setIsLoading(true);
    apigetNominationList({ invRid: investor?.invRid })
      .then((data) => {
        setNominationList(data);
        setIsLoading(false);
      }).catch((error) => {
        setIsLoading(false);
        setErrorData(error);
        setOpenSnackbar(true);
      });
  }

  const getMcaDetails = () => {
    setIsLoading(true);
    apigetMcaList({ invRid: investor?.invRid })
      .then((data) => {
        setMcaList(data.mcaList);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        setErrorData(error);
        setOpenSnackbar(true);
      })
  }

  const getFatcaDetails = () => {
    setIsLoading(true);
    apigetFatcaList({ invRid: investor?.invRid })
      .then((data) => {
        setFatcaList(data);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        setErrorData(error);
        setOpenSnackbar(true);
      })
  }

  const handleEdit = () => {
    setIsDisabled(true);
    getNominationEsignURL({
      "redirectUrl": window.location.origin + "/user/documents"
    })
      .then(({ data, status, description }) => {
        if (status) {
          setTimeout(() => {
            setIsDisabled(false);
            setItem("NOMINATION_ENVELOPE_ID", data.envelopeId);
            if (data.sign_url) {
              localStorage.setItem("Nomination", true);
              window.open(data.sign_url, "_self");
            }
          }, 2000);
        } else {
          setIsDisabled(false);
          setErrorData(description);
        }
      })
      .catch((err) => {
        setIsDisabled(false);
        setErrorData(err);
        setOpenSnackbar(true);
      });
  }

  useEffect(() => {
    getNominationDetails();
    getMcaDetails();
    getFatcaDetails();
  }, []);

  return (

    <CardLayout goHome>
      {
        isLoading ? <div
          className="d-flex justify-content-center align-items-center position-absolute"
          style={{
            width: "90%",
            height: "90%",
          }}
        >
          <div className="spinner-border text-primary" role="status"></div>
        </div> :
          <div>
            <div className="container">
              <h3 className="fs-x-large-semibold mt-2 mt-md-5 mb-0">MCA</h3>

              <table className="table p-0 m-0 my-2">
                <tr className="fs-med-semibold text-muted">

                  <th scope="col">
                    <TableHeadButton
                      label="Envelope Id"
                      activeUp={false}
                      activeDown={false}
                      hideControls
                    />
                  </th>
                  <th scope="col">
                    <TableHeadButton
                      label="Status"
                      activeUp={false}
                      activeDown={false}
                      align="center"
                      hideControls
                    />
                  </th>
                  <th scope="col">
                    <TableHeadButton
                      label="Amount"
                      activeUp={false}
                      activeDown={false}
                      leftAlign
                      hideControls

                    />
                  </th>
                  <th scope="col">
                    <TableHeadButton
                      label="Signed Date"
                      activeUp={false}
                      activeDown={false}
                      align="center"
                      hideControls
                    />
                  </th>

                  <th scope="col">
                    <TableHeadButton
                      label="MCA Files"
                      activeUp={false}
                      activeDown={false}
                      align="center"
                      hideControls
                    />
                  </th>

                </tr>
                {
                  mcaList?.length ?
                    mcaList?.map((data, key) => (
                      <>
                        <tr
                          className="border-bottom pointer row-hover"
                          onClick={() => { }}
                          key={key}
                        >
                          <td className="text-start">
                            <div className="d-flex flex-column ps-1">
                              <p className="fs-6 p-0 m-0">{data.mcaEnvelopId ? data.mcaEnvelopId : 'N/A'}</p>
                            </div>
                          </td>
                          <td className="text-center">
                            <p className="p-0 m-0">
                              <span className={` fs-normal-medium px-2 py-1 transaction-status ${data.mcaStatus === SIGN_STATUS_SUCCESS ? "success" : data.mcaStatus === SIGN_STATUS_FAILED ? "failed" : data.mcaStatus === SIGN_STATUS_PENDING ? "pending" : ""
                                }`}>

                                {data.mcaStatus === SIGN_STATUS_SUCCESS && "Signed"}
                                {data.mcaStatus === SIGN_STATUS_FAILED && "In Review"}
                                {data.mcaStatus === SIGN_STATUS_PENDING && "Partially Signed"}
                              </span>
                            </p>
                          </td>
                          <td className="text-end p-0 m-0">
                            <div className="d-flex flex-column ps-1">
                              <p className="fs-6 p-0 m-0">{data.mcaAmount ? toLocalePrice(data.mcaAmount) : 'N/A'}</p>
                            </div>
                          </td>
                          <td className="text-center">
                            <p className="p-0 m-0">
                              {data.invSignDatetime ?
                                formatDateTime(data.invSignDatetime, false) : "N/A"}
                            </p>
                          </td>
                          <td className="text-center">
                            <p className="p-0 m-0">
                              {
                                data.mcaFiles ? JSON.parse(data?.mcaFiles)?.map((fileData, fileIndex) => {
                                  return (
                                    <Tooltip title={fileData.actualFileName} key={fileIndex}>
                                      <AttachFileIcon color="secondary" onClick={() => window.open(`${BASE_URL}/${fileData.path}`, '_blank')} />
                                    </Tooltip>
                                  );
                                }) : <p>N/A</p>}
                            </p>
                          </td>
                        </tr>
                      </>
                    )) :
                    <tr >
                      <td colspan="4"><p className="text-center">No Records Found</p>
                      </td>
                    </tr>
                }
              </table>
            </div>

            <div className="container">
              <h3 className="fs-x-large-semibold mt-4 mt-md-5 mb-0">Nomination</h3>
              {
                nominationList?.length ?
                  <table className="table p-0 m-0 my-2">
                    <tr className="fs-med-semibold text-muted">
                      <th scope="col">
                        <TableHeadButton
                          label="Envelope Id"
                          activeUp={false}
                          activeDown={false}
                          hideControls
                        />
                      </th>
                      <th scope="col">
                        <TableHeadButton
                          label="Status"
                          activeUp={false}
                          activeDown={false}
                          hideControls
                        />
                      </th>

                      <th scope="col">
                        <TableHeadButton
                          label="Signed Date"
                          activeUp={false}
                          activeDown={false}
                          align="center"
                          hideControls
                        />
                      </th>
                      <th scope="col">
                        <TableHeadButton
                          label="Nomination Files"
                          activeUp={false}
                          activeDown={false}
                          align="center"
                          hideControls
                        />
                      </th>
                    </tr>
                    {
                      nominationList.map((data, key) => (
                        <>
                          <tr
                            className="border-bottom pointer row-hover"
                            onClick={() => { }}
                            key={key}
                          >
                            <td className="text-start">
                              <div className="d-flex flex-column ps-1">
                                <p className="fs-6 p-0 m-0">{data.envelopeId ? data.envelopeId : 'N/A'}</p>
                              </div>
                            </td>
                            <td className="">
                              <p className=" p-0 m-0">
                                <span className={` fs-normal-medium px-2 py-1 transaction-status ${data.signStatus === SIGN_STATUS_SUCCESS ? "success" : data.signStatus === SIGN_STATUS_FAILED ? "failed" : data.signStatus === SIGN_STATUS_PENDING ? "pending" : ""
                                  }`}>
                                  {data.signStatus === SIGN_STATUS_SUCCESS && "Signed"}
                                  {data.signStatus === SIGN_STATUS_FAILED && "In Review"}
                                  {data.signStatus === SIGN_STATUS_PENDING && "Partially Signed"}
                                </span>
                              </p>
                            </td>
                            <td className="text-center">
                              <p className="p-0 m-0">
                                {data.signDatetime ?
                                  formatDateTime(data.signDatetime, false) : "N/A"}
                              </p>
                            </td>
                            <td className="text-center">
                              <p className="p-0 m-0">
                                {data?.nominationFiles && JSON.parse(data?.nominationFiles)?.length ?
                                  JSON.parse(data?.nominationFiles)?.map((fileData, fileIndex) => {
                                    return (
                                      <Tooltip title={fileData.actualFileName} key={fileIndex}>
                                        <AttachFileIcon color="secondary" onClick={() => window.open(`${BASE_URL}/${fileData.path}`, '_blank')} />
                                      </Tooltip>
                                    );
                                  }) : "N/A"}
                              </p>
                            </td>
                            <td className="text-center">
                              <p className="p-0 m-0" disabled={isDisabled}>
                                <Tooltip title={"Edit nomination"} >
                                  {isDisabled ? <EditIcon color="secondary" /> :
                                    <EditIcon color="primary" onClick={() => handleEdit()} disabled={isDisabled} />}
                                </Tooltip>
                              </p>
                            </td>
                          </tr>
                        </>
                      ))}
                  </table> :
                  <div className=''>
                    <p className="text-center fs-large-medium mt-5">We need Nomination details to be included as part of onboarding. We have noticed your nomination details are missing. Kindly use the link below to share your nomination details with us.</p>
                    <div className='d-flex  justify-content-center mt-3'>
                      {getItem(FLAG_REDIRECT_FROM_PREVIEW) ?
                        <button type="button"
                          disabled={!getUserAuth()}
                          style={{ opacity: 0.5 }}
                          className="btn btn-primary px-3 py-2">Continue</button>
                        :
                        <button type="button"
                          disabled={FLAG_REDIRECT_FROM_PREVIEW && !getUserAuth()}
                          onClick={() => {
                            setItem(FLAG_REDIRECT_FROM_DOCUMENTS, true)
                            history.push('/user/nomination')
                          }}
                          className="btn btn-primary px-3 py-2">
                          Continue
                        </button>}
                    </div>
                  </div>
              }
            </div>
            {
              isForeigner() ?
                <div className="container">
                  <h3 className="fs-x-large-semibold mt-4 mt-md-5 mb-0">FATCA</h3>
                  {
                    fatcaList?.length ?
                      <table className="table p-0 m-0 my-2">
                        <tr className="fs-med-semibold text-muted">
                          <th scope="col">
                            <TableHeadButton
                              label="Envelope Id"
                              activeUp={false}
                              activeDown={false}
                            />
                          </th>
                          <th scope="col">
                            <TableHeadButton
                              label="Status"
                              activeUp={false}
                              activeDown={false}
                              hideControls
                            />
                          </th>

                          <th scope="col">
                            <TableHeadButton
                              label="Signed Date"
                              activeUp={false}
                              activeDown={false}
                              align="center"
                            />
                          </th>
                          <th scope="col">
                            <TableHeadButton
                              label="FATCA Files"
                              activeUp={false}
                              activeDown={false}
                              align="center"
                            />
                          </th>
                        </tr>
                        {
                          fatcaList.map((data, key) => (
                            <>
                              <tr
                                className="border-bottom pointer row-hover"
                                onClick={() => { }}
                                key={key}
                              >
                                <td className="text-start">
                                  <div className="d-flex flex-column ps-1">
                                    <p className="fs-6 p-0 m-0">{data.envelopeId ? data.envelopeId : 'N/A'}</p>
                                  </div>
                                </td>
                                <td className="">
                                  <p className=" p-0 m-0">
                                    <span className={` fs-normal-medium px-2 py-1 transaction-status ${data.signStatus === SIGN_STATUS_SUCCESS ? "success" : data.signStatus === SIGN_STATUS_FAILED ? "failed" : data.signStatus === SIGN_STATUS_PENDING ? "pending" : ""
                                      }`}>

                                      {data.signStatus === SIGN_STATUS_SUCCESS && "Signed"}
                                      {data.signStatus === SIGN_STATUS_FAILED && "In Review"}
                                      {data.signStatus === SIGN_STATUS_PENDING && "Partially Signed"}
                                    </span>
                                  </p>
                                </td>
                                <td className="text-center">
                                  <p className="p-0 m-0">
                                    {data.signDatetime ?
                                      formatDateTime(data.signDatetime, false) : "N/A"}
                                  </p>
                                </td>
                                <td className="text-center">
                                  <p className="p-0 m-0">
                                    {data?.fatcaFiles && JSON.parse(data?.fatcaFiles)?.length ?
                                      JSON.parse(data?.fatcaFiles)?.map((fileData, fileIndex) => {
                                        return (
                                          <Tooltip title={fileData.actualFileName} key={fileIndex}>
                                            <AttachFileIcon color="secondary" onClick={() => window.open(`${BASE_URL}/${fileData.path}`, '_blank')} />
                                          </Tooltip>
                                        );
                                      }) : "N/A"}
                                  </p>
                                </td>
                              </tr>
                            </>
                          ))}
                      </table> :
                      <div className=''>
                        <p className="text-center fs-large-medium mt-5">We need FATCA details to be included as part of onboarding. We have noticed your FATCA details are missing. Kindly use the link below to share your FATCA details with us.</p>
                        <div className='d-flex  justify-content-center mt-3'>
                          {getItem(FLAG_REDIRECT_FROM_PREVIEW) ?
                            <button type="button"
                              style={{ opacity: 0.5 }}
                              className="btn btn-primary px-3 py-2">Continue</button> :
                            <button type="button"
                              onClick={() => {
                                setItem(FLAG_REDIRECT_FROM_DOCUMENTS, true)
                                history.push('/user/fatca')
                              }
                              }
                              className="btn btn-primary px-3 py-2">Continue</button>}
                        </div>
                      </div>
                  }
                </div> : null}

          </div>
      }

      <CustomSnackbar
        open={openSnackbar}
        severity="error"
        duration={4000}
        text={errorData}
        handleClose={handleSnackbarClose}
      />
    </CardLayout>
  );
}

export default McaNominationDocuments;
